module.exports = __webpack_public_path__ + "diil-crmfrontend/svg/sprite.11a01144ff5cd215c05faac81df5cdec.svg";